import React from 'react';
import { FormGroup, Label, FormFeedback } from 'reactstrap';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';

const ReactSelect = ({
  containerClasses,
  containerStyle,
  label,
  required,
  invalid,
  error,
  valueKey,
  labelKey,
  ...props
}) => {
  const { t } = useTranslation('app');
  const [data, updateData] = React.useState([]);
  React.useEffect(() => {
    if (props.options.length) {
      updateData(transformData(props.options));
    }
  }, [props.options]);
  function transformData(data) {
    const result = [];
    if (data.length) {
      if (typeof data[0] === 'object') {
        data.forEach((_data) =>
          result.push({
            ..._data,
            value: _data[valueKey],
            label: _data[labelKey],
          }),
        );
      } else {
        data.forEach((_data) =>
          result.push({
            value: _data,
            label: _data,
          }),
        );
      }
    }
    return result;
  }
  function getObjValue(value, data) {
    // eslint-disable-next-line eqeqeq
    return data.filter((_data) => _data.value == value)[0] || null;
  }
  return (
    <FormGroup className={containerClasses} style={containerStyle}>
      {label && (
        <Label className={required ? 'required' : ''}>{t(label)}</Label>
      )}
      <Select
        {...props}
        defaultValue={getObjValue(props.defaultValue, data)}
        options={data}
        onChange={(obj) => props.onChange(obj ? obj : {})}
        value={getObjValue(props.value, data)}
        styles={{
          control: (styles) => ({
            ...styles,
            backgroundColor: 'white',
            borderColor: error ? '#dc3545' : 'hsl(0, 0%, 80%)',
          }),
          option: (styles, { data, isDisabled, isFocused, isSelected }) => {
            return {
              ...styles,
              backgroundColor: isDisabled
                ? undefined
                : isSelected
                ? '#455a64'
                : isFocused
                ? '#78909c'
                : undefined,
              color: isDisabled ? '#ccc' : isSelected ? 'white' : 'black',
              cursor: isDisabled ? 'not-allowed' : 'default',

              //   ':active': {
              //     ...styles[':active'],
              //     backgroundColor: !isDisabled
              //       ? isSelected
              //         ? data.color
              //         : color.alpha(0.3).css()
              //       : undefined,
              //   },
            };
          },
          input: (styles) => ({ ...styles, ...props.inputStyle }),
          singleValue: (styles) => ({ ...styles, ...props.singleValueStyle }),
          menu: (styles) => {
            return {
              ...styles,
              zIndex: 999,
            };
          },
        }}
      />
      {error && <FormFeedback>{t(error)}</FormFeedback>}
    </FormGroup>
  );
};

ReactSelect.defaultProps = {
  placeholder: '...',
  isClearable: true,
  isSearchable: true,
};

export default ReactSelect;
